module.exports = __webpack_public_path__ + "img/check_circle_2.7741f5e4.svg";